import React from 'react'

function orderStatusContent(status) {
  switch (status) {
    case 'sent':
      return <div className="order-status sent-style">ENVIADO</div>
    case 'received':
      return <div className="order-status received-style">RECIBIDO</div>
    case 'dispatched':
      return <div className="order-status dispatched-style">DESPACHADO</div>
    case 'billed':
      return <div className="order-status billed-style">FACTURADO</div>
    case 'cancelled':
      return <div className="order-status cancelled-style">CANCELADO</div>
    case 'tobebilled':
      return <div className="order-status pending-bill-style">POR FACTURAR</div>
    case 'ontheway':
      return <div className="order-status dispatched-style">EN CAMINO</div>
    case 'partial':
      return <div className="order-status partial-style">PARCIAL</div>
    case 'annulled':
      return <div className="order-status annulled-style">ANULADO</div>
    default:
      return null
  }
}

const OrderStatusBlock = ({ model }) => (
  <div className="td-order-status">{orderStatusContent(model['order_status'])}</div>
)

export default OrderStatusBlock
